// Components
import { RootState } from '../index';

const getAccountRoots = (state: RootState) => state.accountRootsDataSlice.account_roots;

export {
  getAccountRoots,
};
